import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/shared/constants';
import { useAuth } from '@/infrastructure/auth';
import { fetchIterations } from '../../api';

export function useIterations() {
  const { tenantUuid } = useAuth();

  return useQuery({
    queryKey: [QUERY_KEYS.AZURE_DEVOPS_ITERATIONS, tenantUuid],
    queryFn: fetchIterations,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes - iterations rarely change
  });
}
